import React from 'react';
import { AttachmentPills } from './AttachmentPills.jsx';

export function MessageAttachmentContextRow({
  attachments = [],
  role = '',
  themeTokens,
}) {
  if (role !== 'user' || !Array.isArray(attachments) || attachments.length === 0) {
    return null;
  }
  return (
    <div
      className="flare-message-attachment-context-row"
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 6,
        width: '100%',
      }}
    >
      <div style={{ maxWidth: '78%' }}>
        <AttachmentPills
          attachments={attachments}
          isUser
          themeTokens={themeTokens}
        />
      </div>
    </div>
  );
}
